import React from "react";

class Message extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                //background:"#c7daf4",
                margin:"10px",
                //float:"right",
                //borderRadius:"50%",
                //width:"25px",
                //height:"25px",
                //fontWeight:"bold",
                //cursor:"pointer",
                //textAlign:"center",
                //paddingTop:"2px"
            },
            ident: "msg"
        }
    }
    render() {
        return (
            <div>
                <p className="attn" style={{textDecoration:"underline", fontStyle:"italic"}}>Is proposed scale-up feasible?</p>
                <p className={this.state.ident} style={this.state.style}>{this.props.msg}</p>

            </div>
        )
    }
}

export default Message;


// WEBPACK FOOTER //
// ./src/message.js